import { render } from "./Bills.vue?vue&type=template&id=08d5733e&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"

import "./Bills.vue?vue&type=style&index=0&id=08d5733e&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d5733e"]])

export default __exports__